import { styled } from "@mui/material";
import * as React from "react";

const Container = styled('div')(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexFlow: "column nowrap",
    position: "relative",
    height: "100%",

    "& .quill": {
        position: "absolute",
        height: "100%",
        maxHeight: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },

    "& .ql-container": {
        borderBottomLleftRadius: "0.5em",
        borderBottomRightRadius: "0.5em",
        background: "#fefcfc",
        overflow: "auto",
        flexGrow: 1
    },

    /* Transparent Theme */
    "& .ql-transparent .ql-container": {
        border: 0,
        background: "#fff",
        padding: 2
    },

    "& .ql-transparent .ql-toolbar": {
        display: "block",
        background: "#fff",
        border: 0
    },
    "& .ql-transparent .ql-editor": {
        background: "#fff",
        border: 0,
        padding: 0
    },

    /* Snow Theme */
    "& .ql-snow.ql-toolbar": {
        background: "#eaecec",
    },

    /* Bubble Theme */
    "& .ql-bubble.ql-editor": {
        border: "1px solid #ccc",
        "border-radius": "0.5em",
    },

    "&.quill-container-editor": {
        minHeight: "10rem",
        "& .quill": {
            position: "absolute",
        },
    },

}));

interface IProps {
    id?: string;
    viewOnly?: boolean;
    showToolbar?: boolean;
}

type Props = IProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const MprcQuillContainer: React.FC<Props> = (props) => {
    const { id, className, children, viewOnly = false, style, showToolbar = true } = props;

    const cls = [
        className,
        (showToolbar ? undefined : "ql-hide-toolbar"),
        (viewOnly ? undefined : "quill-container-editor")
    ].filter(v => v != undefined).join(' ');

    if (viewOnly)
        return (
            <Container id={id} className={cls}>
                <div className="quill">
                    <div className="ql-snow">
                        <div className="ql-editor">
                            {children}
                        </div>
                    </div>
                </div>
            </Container>
        );

    return (
        <Container id={id} className={cls} style={style}>
            {children}
        </Container>
    );
};
